module.exports = __webpack_public_path__ + "images/newerp_button2.1789545008192.png";